import ImagesUrl from "#constants/images.js";
import React from "react";

export default function CustomTable({
  tableHeader,
  children,
  customClass,
  iconRequire,
  handelClick,
}) {
  return (
    <div className={`table-blk table-responsive ${customClass}`}>
      <table className="table border-0 mb-0">
        <thead>
          <tr>
            {tableHeader.map((item, index) => (
              <th key={index}>
                {item.name}
                {index === 1 &&
                  (iconRequire ? (
                    <img
                      src={ImagesUrl.arrow}
                      alt="..."
                      style={{ cursor: "pointer" }}
                      onClick={() => handelClick()}
                    />
                  ) : null)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
